export const GENERAL_QUESTIONS = [
  'What are trending home improvement projects for 2025?',
  'How can I make my home more energy efficient?',
  'Which BBQ grills are best for small patios?',
  'What are the most popular paint colors this year?',
  'What are the top 5 home maintenance tasks that homeowners forget?',
  'How do I repair a faucet?',
  'What are the top DIY hacks for renters?',
  'How can I organize my garage efficiently?',
  'What are the best tools for a beginner DIYer?',
  'How can I add more natural light to my space?',
  'What are some easy weekend projects to transform a space?',
  'What’s the easiest way to update my cabinets?',
  'What are creative storage ideas?',
  'What’s the best way to tackle multiple projects?',
  'What’s one quick win for my home today?',
  'How do I prevent mold and mildew in my bathroom?',
  'How do I clean hard-to-reach areas effectively?',
  'How can I make my kitchen more functional?',
  'What’s the best way to upgrade my bathroom?',
  'How do I make sure I get everything I need in one trip?',
  'How do I choose the right paint color for my room?',
  'What’s the most affordable way to update my bathroom?',
  'Which flooring options are the best for pet owners?',
  'How do I brighten up my space for spring?',
  'What are the best plants for low-maintenance landscaping?',
  'How do I get the best looking yard on the block?',
  'How do I grow grass?',
  'How do I fertilize my lawn?',
  'Does Home Depot offer online purchase and delivery of plants?',
  'Should I get battery or gas-powered outdoor equipment?',
  'Do you have weather-resistant furniture for outdoor spaces?',
  'How do I calculate deck materials?',
  'What products do I need if I’m moving?',
  'What are some great storage solutions to help me declutter?',
];

export const PIP_QUESTIONS = [
  'What is the warranty on this item?',
  'What are the delivery options for this item?',
  'What do I need to know before using it?',
  'What do I need to know before I buy?',
  'What are the key features?',
  'What are the top uses for this product?',
  'Can this item be returned or exchanged?',
  'What are the key specifications?',
  'How soon can I get this delivered to my zip code?',
  'What is the delivery charge for this item?',
];
